module.exports = __webpack_public_path__ + "static/img/img_nfuMainNew.18a73bd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/etc/img_nfuMainNew.jpg
// module id = KGjR
// module chunks = 1